import React from "react";
import { Modal, Button, Form, Input } from "antd";
import axios from "../../services/axiosConfig";
import Helper from "../../services/Helper";
import Notification from "../../services/Notification";

const ShopPopup = ({ show, close }) => {
  const [form] = Form.useForm();

  const handleOk = async () => {
    try {
      let obj = form.getFieldsValue();
      if (obj.password) {
        const data = await axios.patch("/changepsw", obj).catch((error) => {
          Helper.ErrorHanlder(error);
        });
        if (data && data.data) {
          Notification.success(`Password Changed Successfully`);
          close(data);
        }
      }
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  };

  const handleCancel = () => {
    close();
  };

  return (
    <>
      <Modal
        title={"Update Password"}
        open={show}
        onCancel={handleCancel}
        footer={false}
      >
        <Form
          layout={"vertical"}
          form={form}
          size={"small"}
          labelCol={{
            span: 6,
          }}
          style={{
            marginTop: 30,
          }}
          onFinish={handleOk}
        >
          <Form.Item
            label="New Password"
            name="password"
            rules={[
              {
                required: true,
                message: "Password is required",
              },
            ]}
          >
            <Input placeholder="input placeholder" />
          </Form.Item>
          <Form.Item className="popup-submit">
            <Button className="popup-cancel-btn" onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              className="popup-submit-btn"
              onClick={handleOk}
            >
              Change
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default ShopPopup;
